module.exports = __webpack_public_path__ + "athena-shield.7dfad6ac3ba13441067dd13eb8947647.svg";